import React from 'react';
import { useAirtableExtras } from '../hooks/useAirtableExtras';
import { Loader } from '../Loader';

interface FieldProps {
  product_name: string;
  product_cost: string[];
}

export const Extras = (): React.ReactElement => {
  const [extraItems, isLoading] = useAirtableExtras();

  if (isLoading) return <Loader />

  return (
    <div className='container mx-auto w-full md:w-2/3 mb-14 border-2 border-b-0'>
      {extraItems.map(({ fields }: { fields: FieldProps }) => {
        return (
          <div
            key={fields.product_name}
            className='
              flex flex-row gap-4 md:gap-0
              items-center justify-between
              p-4 border-b-2'
          >
            <div className='flex w-full'>
              <p className='font-black'>{fields.product_name}</p>
            </div>

            <div className='flex items-center gap-2'>
              {fields.product_cost?.map((cost, index) => {
                return (
                  <div className='flex flex-col items-center p-4 border-2 border-black rounded-xl'>
                    <p>{cost}</p>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};
